export default __webpack_public_path__ + "static/media/user.d7f2d031.png";